import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import { IPermissionRequestsResponse, ITableRequestData } from "../../types/common";

import { getPermissionTableService } from "../../api/permissionApi";
import { PermissionState } from "../../types/features/permissionSlice";


export const getPermissionData = createAsyncThunk<IPermissionRequestsResponse, ITableRequestData>(
    "permission/getPermissionData", async ({ limit, page }) => {
        const response = await getPermissionTableService({
            limit,
            page
        });
        return response.data;
    });


const PermissionSlice = createSlice({
    name: "Permission",
    initialState: {
        permissionLoader: false,
        status: false,
        msg: "",
        data: null,
        detail: null,
    } as PermissionState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPermissionData.pending, (state) => {
                state.permissionLoader = true;
            })
            .addCase(getPermissionData.fulfilled, (state, action: PayloadAction<IPermissionRequestsResponse>) => {
                state.data = action.payload.data;
                state.msg = action.payload.message;
                state.status = true;
                state.permissionLoader = false;
            })
            .addCase(getPermissionData.rejected, (state, action) => {
                state.permissionLoader = false;
                state.status = false;
                state.msg = action.error.message;
            });
    },
});

export default PermissionSlice.reducer;
